export default {
  common: {
    appName: 'AuthentiGuard',
    loading: '加载中...',
    confirm: '确认',
    cancel: '取消',
    back: '返回',
    more: '更多',
    search: '搜索',
    submit: '提交',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    view: '查看',
    required: '必填',
    optional: '可选',
    allRightsReserved: '所有权利保留',
    noMoreData: '没有更多数据了',
    loadMoreText: '上拉加载更多',
    close: '关闭',
    // submit: '提交申请',
    submitting: '提交中...',
    submitSuccess: '提交成功',
    submitFailed: '提交失败，请重试',
    // required: '此字段为必填项',
    upload: '上传',
    agreeTerms: '我已阅读并同意相关条款',
    agreeTermsRequired: '请阅读并同意相关条款',
    applyNow: '立即申请',
    preview: '店铺预览',
    brandGuide: '品牌导览',
    copy: '复制',
    systemMessage: '系统消息',
    ok: '好的'
  },
  nav: {
    home: '首页',
    verification: '鉴伪',
    report: '投诉',
    achievements: '成果',
    calendar: '日历',
    brands: '品牌馆',
    cooperationCenter: '合作中心',
    login: '登录/注册'
  },
  home: {
    heroTitle: '守护每一份真实，信任从这里开始',
    heroSubtitle: '为品牌方与消费者构筑全方位的防伪护城河',
    verifyNow: '立即鉴伪',
    reportFake: '举报伪冒',
    coreFeatures: '我们的核心功能',
    oneClickVerification: '一键鉴伪',
    oneClickVerificationDesc: '快速验证产品真伪，保护您的消费权益',
    anonymousReport: '匿名举报',
    anonymousReportDesc: '安全举报假冒产品，共同维护市场秩序',
    industryCalendar: '行业日历',
    comprehensiveSolution: '全方位防伪解决方案，保护您的品牌与消费权益',
    reportNow: '我要举报',
    viewCalendar: '查看日历',
    industryCalendarDesc: '掌握品牌最新动态与活动安排',
    trustedBrands: '众多品牌的选择，值得信赖',
    platformAchievements: '平台成果展示',
    latestNews: '最新动态',
    verifiedProducts: '累计鉴定商品',
    handledComplaints: '处理投诉起数',
    partnerBrands: '合作品牌',
    userSatisfaction: '用户满意度',
    viewAllBrands: '查看更多合作品牌',
    viewReport: '查看详细数据报告',
    quickVerification: '快速验证',
    security: '安全保障',
    realTimeUpdates: '实时更新',
    scanToExperience: '扫码体验',
    scanDescription: '使用手机扫描二维码，立即体验产品功能'
  },
  auth: {
    login: '登录',
    register: '注册',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码',
    noAccount: '没有账号？去注册',
    haveAccount: '已有账号？去登录',
    loginSuccess: '登录成功',
    registerSuccess: '注册成功',
    logoutSuccess: '退出成功'
  },
  verification: {
    title: '扫码鉴伪',
    // scanCode: '扫码验证',
    demoCode: '使用案例验证',
    demoTip: '若您当前暂无产品防伪码，可以使用我们提供的案例验证',
    enterCode: '输入防伪码',
    verify: '验证',
    verificationResult: '验证结果',
    genuineProduct: '正品',
    fakeProduct: '假冒产品',
    verificationHistory: '验证历史',
    batchVerification: '批量验证',
    // scanTip: '将二维码放入框内，即可自动扫描',
    scanGuide: '对准二维码，自动扫描',
    codeRequired: '请输入防伪码',
    codeTooShort: '防伪码长度不足',
    codeInvalid: '防伪码无效',
    verifyFailed: '验证失败',
    verifying: '验证中...',
    scanSuccess: '扫码成功',
    cameraNotAvailable: '摄像头不可用',

    // 验证结果
    authenticProduct: '正品验证',
    verifiedProduct: '已验证产品',
    // scanInfo: '扫描信息',
    // isFirstScan: '首次扫描',
    // scanTimes: '扫描次数',
    // firstScanTime: '首次扫描时间',
    // currentScanTime: '本次扫描时间',
    scanInfo: '验证信息',
    isFirstScan: '是否首次扫描验证',
    scanTimes: '扫描次数',
    firstScanTime: '首次扫描验证时间',
    currentScanTime: '本次扫描验证时间',
    yes: '是',
    no: '否',

    // 商品信息
    commodityInfo: '商品信息',
    unknownProduct: '未知商品',
    styleNo: '款号',
    color: '颜色',
    size: '尺码',
    category: '品类',
    country: '国家',
    collection: '系列',

    // 操作
    verifyAnother: '验证其他产品',
    shareResult: '分享验证结果',
    shareTitle: '分享验证结果',
    sharing: '分享到',
    linkCopied: '链接已复制',

    // 状态
    noResult: '未找到验证结果',
    tryAgain: '重新尝试'
  },
  report: {
    title: '举报伪冒',
    brandInfo: '品牌信息',
    productInfo: '产品信息',
    purchaseInfo: '购买信息',
    problemInfo: '问题描述',
    contactInfo: '联系信息',

    brand: '品牌',
    brandName: '品牌名称',
    brandPlaceholder: '请选择品牌名称',
    brandRequired: '请选择品牌名称',
    selectBrand: '选择品牌',
    customBrand: '自定义品牌',
    customBrandPlaceholder: '请输入品牌名称',
    customBrandRequired: '请输入品牌名称',

    productName: '产品名称',
    productNamePlaceholder: '请输入产品具体名称',
    productNameRequired: '请输入产品名称',

    purchaseChannel: '购买渠道',
    purchaseChannelPlaceholder: '例如：天猫旗舰店、实体店等',
    purchaseChannelRequired: '请输入购买渠道',

    purchaseDate: '购买时间',
    purchaseDatePlaceholder: '请选择购买日期',
    purchaseDateRequired: '请选择购买日期',
    selectDate: '选择日期',

    problemDescription: '问题描述',
    problemDescriptionPlaceholder: '请详细描述您遇到的问题，例如：产品外观异常、防伪标签破损、使用效果与正品不符等',
    problemDescriptionRequired: '请描述问题详情',

    evidencePhotos: '证据照片',
    uploadTip: '最多可上传5张照片，支持JPG、PNG格式，每张不超过5MB',

    anonymousTip: '选择匿名举报后，您的个人信息将不会被记录。如需后续跟进，请关闭匿名选项。',
    contactName: '联系人',
    contactNamePlaceholder: '请输入您的姓名',
    contactNameRequired: '请输入联系人姓名',
    contactPhone: '联系手机',
    contactPhonePlaceholder: '请输入您的手机号码',
    contactPhoneRequired: '请输入手机号码',
    phoneFormatError: '请输入正确的手机号码格式',

    anonymousReport: '匿名举报',
    submitReport: '提交举报',
    submitting: '提交中...',
    agreementTip: '提交即表示您同意我们的',
    userAgreement: '用户协议',

    successMessage: '感谢您的举报！我们已收到您的信息。您可以通过举报记录查看处理进度。',
    viewReport: '查看举报记录',
    submitAnother: '继续举报',

    purchaseLocation: '购买地点',
    submitSuccess: '提交成功',
    thankYou: '感谢您的提交',
    caseNumber: '投诉编号',
    trackProgress: '查询处理进度',
    scanToTrack: '扫描二维码随时查询投诉处理进度',
    progressQrAlt: '投诉进度查询二维码'

    // description: '问题描述',
    // uploadEvidence: '上传证据',
    // reportSuccess: '举报提交成功'
  },
  brands: {
    title: '品牌馆',
    allBrands: '合作品牌',
    featuredBrands: '推荐品牌',
    productCount: '产品数量',
    verificationCount: '验证次数',
    learnMore: '了解更多',
    pageSubtitle: '探索与我们合作的优质品牌，共同守护产品真实',
    searchPlaceholder: '搜索品牌名称或描述...',
    noBrandsFound: '未找到相关品牌',
    resetFilters: '重置筛选条件',
    featured: '推荐品牌',
    products: '产品',
    verifications: '验证',
    viewDetails: '查看详情',
    joinTime: '加入于',
    establishTime: '成立于',
    story: '品牌故事',
    designers: '设计师团队',
    verification: '品牌认证',
    totalVerifications: '总验证次数',
    authenticityRate: '真品率',
    items: '件商品',
    verified: '已认证'
  },
  footer: {
    aboutUs: '关于我们',
    contact: '联系我们',
    privacy: '隐私政策',
    terms: '服务条款',
    newsletter: '订阅动态',
    newsletterDesc: '订阅我们的新闻通讯，获取最新防伪资讯',
    enterEmail: '请输入您的邮箱',
    subscribe: '订阅'
  },
  errors: {
    networkError: '网络错误，请稍后重试',
    serverError: '服务器错误',
    notFound: '请求的资源不存在',
    unauthorized: '未授权访问',
    invalidCredentials: '邮箱或密码错误',
    emailRequired: '请输入邮箱',
    passwordRequired: '请输入密码',
    passwordMinLength: '密码长度不能少于6位',
    passwordNotMatch: '两次密码输入不一致'
  },
  calendar: {
    title: '行业日历',
    subtitle: '掌握品牌最新动态与活动安排',
    monthView: '月视图',
    listView: '列表视图',
    viewDetails: '查看详情',
    eventDescription: '活动描述',
    participate: '立即参与',
    noEvents: '没有相关活动',

    // 事件类型
    // conference: '会议',
    // exhibition: '展览',
    // webinar: '线上研讨会',
    // promotion: '促销活动',
    // deadline: '截止日期',
    showRoom: 'ShowRoom',
    exhibition: '展会',
    tradeFair: '订货会',
    event: '活动',

    // 月份
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',

    // week
    monday: '一',
    tuesday: '二',
    wednesday: '三',
    thursday: '四',
    friday: '五',
    saturday: '六',
    sunday: '日'
  },
  progress: {
    title: '投诉进度查询',
    enterComplaintId: '请输入投诉编号',
    search: '查询',
    scanQrCode: '扫码查询',
    invalidId: '请输入有效的投诉编号（至少8位字母数字）',
    searchFailed: '查询失败，请重试',

    complaintId: '投诉编号',
    submitTime: '提交时间',
    productName: '产品名称',
    complaintType: '投诉类型',
    description: '问题描述',

    progressTitle: '处理进度',
    statusPending: '待处理',
    statusInProgress: '处理中',
    statusCompleted: '已完成',
    statusClosed: '已关闭',

    resultTitle: '处理结果',
    result: '处理结果',
    solution: '解决方案',
    followUp: '后续跟进',

    operator: '处理人员',

    needHelp: '需要帮助？',
    contactCustomerService: '联系我们的客服团队',
    contactNow: '立即联系',
    contactService: '联系客服',
    contactConfirm: '您将联系我们的客服团队，是否继续？',
    contactingService: '正在联系客服...',

    howToUse: '使用说明',
    instruction1: '在输入框中输入您的投诉编号',
    instruction2: '或点击"扫码查询"扫描投诉回执上的二维码',
    instruction3: '点击查询按钮查看投诉处理进度',

    noData: '未找到相关投诉记录',
    searchAgain: '重新查询',

    scanPlaceholder: '请将二维码对准摄像头',
    mockScan: '模拟扫码'
  },
  dynamic: {
    detail: '动态详情',
    views: '浏览'
  },
  applications: {
    department: {
      title: '百货店合作申请',
      subtitle: '成为我们的零售伙伴，共享品牌生态资源',
      storeName: '百货店名称',
      storeNamePlaceholder: '请输入百货店名称',
      groupName: '所属集团',
      groupNamePlaceholder: '请输入所属集团名称',
      country: '国家',
      countryPlaceholder: '请输入国家',
      city: '城市',
      cityPlaceholder: '请输入城市',
      address: '详细地址',
      addressPlaceholder: '请输入详细地址',
      storeLevel: '商场定位',
      storeLevelOptions: {
        highEnd: '高端',
        midHigh: '中高端',
        mass: '大众'
      },
      businessArea: '营业面积(m²)',
      businessAreaPlaceholder: '请输入营业面积',
      annualTraffic: '年客流量',
      annualTrafficPlaceholder: '请输入年客流量',
      existingBrands: '现有主要品牌',
      existingBrandsPlaceholder: '请简要描述商场内现有的主要品牌...',
      cooperationDescription: '合作期望',
      cooperationDescriptionPlaceholder: '请描述您希望通过合作达成的目标...'
    },
    brand: {
      title: '品牌合作加盟申请',
      subtitle: '入驻品牌生态圈，享受全链路支持',
      brandNameCn: '品牌中文名',
      brandNameCnPlaceholder: '请输入品牌中文名',
      brandNameEn: '品牌英文名',
      brandNameEnPlaceholder: '请输入品牌英文名',
      brandCountry: '品牌发源地',
      brandCountryPlaceholder: '请输入品牌发源地',
      establishedYear: '创立年份',
      establishedYearPlaceholder: '请输入创立年份',
      brandPositioning: '品牌定位',
      brandPositioningOptions: {
        luxury: '奢侈品',
        highEnd: '高端',
        designer: '设计师品牌',
        contemporary: '当代时尚',
        mass: '大众品牌'
      },
      mainCategories: '主营品类',
      mainCategoriesPlaceholder: '请输入主营品类，如：女装、配饰',
      existingChannels: '现有销售渠道',
      existingChannelsPlaceholder: '请输入现有销售渠道，如：线上官网、线下门店',
      annualRevenue: '年营业额(元)',
      annualRevenuePlaceholder: '请输入年营业额',
      companyName: '公司名称',
      companyNamePlaceholder: '请输入公司名称',
      cooperationDescription: '合作描述',
      cooperationDescriptionPlaceholder: '请描述您希望通过合作达成的目标...'
    },
    designer: {
      title: '设计师入驻申请',
      subtitle: '展示创意才华，连接品牌与消费者',
      designerName: '设计师姓名',
      designerNamePlaceholder: '请输入设计师姓名',
      brandName: '品牌名称',
      brandNamePlaceholder: '请输入品牌名称',
      designField: '设计领域',
      designFieldPlaceholder: '请输入设计领域，如：服装设计',
      experienceYears: '从业年限',
      experienceYearsPlaceholder: '请输入从业年限',
      educationBackground: '教育背景',
      educationBackgroundPlaceholder: '请输入教育背景',
      workExperience: '工作经历',
      workExperiencePlaceholder: '请输入工作经历',
      representativeWorks: '代表作品',
      representativeWorksPlaceholder: '请输入代表作品',
      awards: '所获奖项',
      awardsPlaceholder: '请输入所获奖项',
      personalIntroduction: '个人介绍',
      personalIntroductionPlaceholder: '请简要介绍您的设计理念、经历与成就...'
    },
    officer: {
      title: '行政官招募申请',
      subtitle: '成为区域管理者，协调品牌与百货店关系',
      applicantName: '申请人姓名',
      applicantNamePlaceholder: '请输入申请人姓名',
      appliedPosition: '申请职位',
      appliedPositionPlaceholder: '请输入申请职位',
      experienceYears: '工作年限',
      experienceYearsPlaceholder: '请输入工作年限',
      educationBackground: '教育背景',
      educationBackgroundPlaceholder: '请输入教育背景',
      workExperience: '工作经历',
      workExperiencePlaceholder: '请输入工作经历',
      professionalSkills: '专业技能',
      professionalSkillsPlaceholder: '请输入专业技能',
      projectExperience: '项目经验',
      projectExperiencePlaceholder: '请输入项目经验',
      selfIntroduction: '自我介绍',
      selfIntroductionPlaceholder: '请简要介绍您的个人情况和职业经历...'
    },
    contactInfo: '联系信息',
    contactName: '联系人姓名',
    contactNamePlaceholder: '请输入联系人姓名',
    contactPosition: '职务',
    contactPositionPlaceholder: '请输入职务',
    contactPhone: '联系电话',
    contactPhonePlaceholder: '请输入联系电话',
    contactEmail: '电子邮箱',
    contactEmailPlaceholder: '请输入电子邮箱',
    agreeTerms: '我已阅读并同意相关条款',
    agreeTermsRequired: '请阅读并同意相关条款',
    // todo
    submitSuccess: '提交成功，我们将会尽快与您联系'
  },
  cooperation: {
    center: '合作中心',
    applicationCenter: '合作申请中心',
    departmentStores: '合作百货店展示',
    noStores: '数据正在更新中',
    applyFirstStore: '我要申请合作',
    department: {
      title: '百货店合作',
      subtitle: '成为我们的零售伙伴',
      description: '链接全球优质客群，提升商场品牌力与流量。'
    },
    brand: {
      title: '品牌合作加盟',
      subtitle: '入驻品牌生态圈',
      description: '为您的品牌提供从防伪到销售的全链路支持。'
    },
    designer: {
      title: '设计师入驻',
      subtitle: '展示您的创意',
      description: '连接品牌与消费者，打造个人设计IP。'
    },
    officer: {
      title: '行政官招募',
      subtitle: '成为区域合作管理者',
      description: '协调品牌与百货店关系，推动区域业务发展。'
    },
    benefits: {
      department: [
        '全渠道品牌曝光',
        '会员体系打通',
        '营销活动支持',
        '数据分析服务'
      ],
      brand: [
        '防伪溯源技术',
        '多渠道销售网络',
        '品牌推广资源',
        '活动联动支持'
      ],
      designer: [
        '个人品牌展示',
        '商业合作机会',
        '作品版权保护',
        '行业交流平台'
      ],
      officer: [
        '区域业务管理权',
        '丰厚绩效奖励',
        '专业培训体系',
        '职业发展通道'
      ]
    }
  },
  preview: {
    story: '品牌故事',
    designer: '设计师',
    products: '近期款式',
    events: '品牌动态',
    origin: '品牌起源',
    originContent: '浮光品牌创立于2018年，源于创始人对于现代女性日常着装的思考。我们相信服装不仅是遮体之物，更是表达自我、传递态度的媒介。品牌名称"浮光"取自"浮光掠影"，寓意捕捉生活中转瞬即逝的美好瞬间，将其凝固于服装设计之中。',
    designConcept: '设计理念',
    designConceptContent: '浮光致力于将东方美学与现代设计语言相结合，创造既符合当代生活节奏，又蕴含文化底蕴的服装。我们注重面料的选择与工艺的细节，追求舒适与美感的平衡。',
    designerTitle: '首席设计师 & 品牌创始人',
    designerDesc: '毕业于清华大学美术学院，曾任职于国际知名时装品牌，拥有10年服装设计经验。擅长将传统工艺与现代审美融合，创造具有独特东方韵味的当代服装。',
    collection: '2023秋冬系列 - "城市光影"',
    collectionDesc: '本系列从都市建筑线条与光影变化中汲取灵感，运用简洁的剪裁与柔和的色调，打造适合现代都市女性的日常着装。'
  },
  stores: {
    beijingSKP: {
      name: '北京SKP',
      location: '北京市朝阳区建国路87号',
      tags: ['奢侈品', '旗舰店', '设计师集合']
    },
    shanghaiIFC: {
      name: '上海IFC国金中心',
      location: '上海市浦东新区世纪大道8号',
      tags: ['高端购物', '国际品牌']
    },
    shenzhenMixC: {
      name: '深圳万象城',
      location: '深圳市罗湖区宝安南路1881号',
      tags: ['生活方式', '潮流品牌', '餐饮娱乐']
    },
    chengduTaikooli: {
      name: '成都太古里',
      location: '成都市锦江区中纱帽街8号',
      tags: ['开放式街区', '文化地标', '设计师品牌']
    }
  },
  portal: {
    hero: {
      title: '构建品牌生态，创造无限可能',
      subtitle: '逐日集团业务统一入口平台，整合防伪、品牌、渠道与活动资源，构建完整的商业生态系统',
      experienceBtn: '立即体验',
      learnMoreBtn: '了解更多',
      experienceToast: '开始探索生态门户',
      introductionContent: '官网域名正在升级中，敬请期待～'
    },
    features: {
      title: '核心功能',
      experienceLink: '立即体验',
      antiCounter: {
        title: '防伪平台',
        description: '产品鉴伪、防伪举报、溯源查询，保护品牌价值与消费者权益'
      },
      cooperation: {
        title: '合作中心',
        description: '百货店合作、品牌加盟、设计师入驻、行政官招募，一站式合作申请'
      },
      brandEcosystem: {
        title: '品牌生态',
        description: '品牌展示、店铺导览、设计师故事，探索完整品牌生态体系'
      },
      calendar: {
        title: '活动日历',
        description: '时装周、订货会、行业展会，掌握最新行业动态与活动信息'
      }
    },
    brands: {
      title: '合作品牌墙'
      // fuguang: {
      //   name: '浮光'
      // },
      // yayun: {
      //   name: '雅韵'
      // },
      // naturalism: {
      //   name: '自然主义'
      // },
      // qingyu: {
      //   name: '轻羽'
      // },
      // shanlan: {
      //   name: '山岚'
      // },
      // liushui: {
      //   name: '流水'
      // }
    },
    stats: {
      brands: '合作品牌',
      departmentStores: '合作百货店',
      designers: '认证设计师',
      officers: '区域行政官'
    },
    footer: {
      about: {
        title: '关于我们',
        introduction: '集团介绍',
        history: '发展历程',
        culture: '企业文化',
        contact: '联系我们'
      },
      cooperation: {
        title: '业务合作',
        departmentStores: '百货店合作',
        brands: '品牌加盟',
        designers: '设计师入驻',
        officers: '行政官招募'
      },
      help: {
        title: '帮助中心',
        faq: '常见问题',
        guide: '使用指南',
        terms: '服务条款',
        privacy: '隐私政策'
      },
      follow: {
        title: '关注我们',
        description: '获取最新行业动态与活动信息'
      },
      copyright: '© 2025 逐日集团平台 版权所有 沪ICP备2022009059号-3'
    },
    contact: {
      title: '联系我们',
      description: '请通过以下邮箱联系我们，我们将尽快回复您',
      copySuccess: '邮箱地址已复制到剪贴板'
    }
  },
  faq: {
    title: '常见问题',
    searchPlaceholder: '搜索问题...',
    foundQuestions: '找到 {count} 个相关问题',
    noQuestionsFound: '没有找到相关问题',
    resetSearch: '重置搜索',
    relatedLinks: '相关链接',
    needMoreHelp: '需要更多帮助？',
    contactUs: '联系我们',
    contactToast: '正在联系客服...',
    categories: {
      all: '全部',
      cooperation: '合作相关',
      application: '申请流程',
      technical: '技术支持',
      account: '账户问题'
    },
    questions: {
      q1: {
        title: '如何申请百货店合作？',
        answer: '您可以通过我们的合作中心提交百货店合作申请。申请时需要提供百货店的基本信息、经营状况、现有品牌情况以及合作期望等。我们的商务团队会在15个工作日内与您联系。',
        links: {
          department: '百货店合作申请',
          brand: '品牌合作申请'
        }
      },
      q2: {
        title: '设计师入驻需要什么条件？',
        answer: '设计师入驻需要提供个人作品集、设计理念说明以及相关资质证明。我们欢迎有创意、有独特设计风格的设计师加入我们的平台。审核周期通常为10-15个工作日。',
        links: {
          designer: '设计师入驻申请',
          officer: '行政官招募'
        }
      },
      q3: {
        title: '申请审核需要多长时间？',
        answer: '不同类型的申请审核时间不同：百货店合作申请约10-15个工作日，品牌合作申请约10-15个工作日，设计师入驻申请约10-15个工作日，行政官招募申请约13-17个工作日。',
        links: {}
      },
      q4: {
        title: '如何查询申请状态？',
        answer: '您可以在个人中心的"我的申请"页面查看所有申请的状态。审核通过后，我们也会通过邮件和短信通知您。',
        links: {}
      },
      q5: {
        title: '系统出现技术问题怎么办？',
        answer: '如果遇到技术问题，请先检查网络连接和浏览器版本。如果问题持续存在，请联系我们的技术支持团队，提供详细的问题描述和截图，我们会尽快为您解决。',
        links: {}
      },
      q9: {
        title: '合作有哪些优势？',
        answer: '与我们合作可以享受品牌曝光、渠道资源、技术支持、营销活动等多方面的支持。我们致力于为合作伙伴创造最大价值。',
        links: {}
      },
      q10: {
        title: '申请被拒绝后可以重新申请吗？',
        answer: '可以的。如果申请被拒绝，我们会说明具体原因。您可以根据反馈改进后重新提交申请，建议间隔至少30天。',
        links: {}
      }
    }
  },
  guard: {
    heroTitle: '正品验证，一触即达',
    heroSubtitle: '三种查询方式，全方位保障您的购物安全',
    verification: '验证',
    antiFakeQuery: '鉴伪查询',
    antiFakeDesc: '通过防伪码验证商品真伪',
    antiFakeTips: '请输入商品上的防伪码进行验证',
    tagQuery: '吊牌查询',
    tagDesc: '通过吊牌信息验证商品详情',
    tagTips: '请输入吊牌上的款式信息进行查询',
    packageQuery: '包装查询',
    packageDesc: '验证包装袋/盒的真伪信息',
    packageTips: '请输入包装上的防伪码进行验证',

    enterAntiFakeCode: '请输入防伪码',
    verifyNow: '立即验证',
    scanCodeVerify: '扫码验证',
    howToFindCode: '如何找到防伪码？',
    tip1: '在商品标签上找到防伪涂层',
    tip2: '刮开涂层即可看到防伪码',
    tip3: '输入防伪码进行验证',

    enterStyleNumber: '请输入款号',
    enterSize: '请输入尺码',
    enterColor: '请输入颜色',
    styleNumber: '款号',
    size: '尺码',
    color: '颜色',
    queryTagInfo: '查询吊牌信息',
    tagExample: '吊牌示例',
    tagExampleDesc: '请在吊牌上找到对应的信息',

    selectPackageType: '选择包装类型',
    packageBag: '包装袋',
    packageBox: '包装盒',
    enterBagCode: '请输入包装袋防伪码',
    enterBoxCode: '请输入包装盒防伪码',
    verifyPackage: '验证包装',
    packageFeatures: '包装防伪特征',
    feature1: '专用防伪材质',
    feature2: '一次性封装设计',
    feature3: '专属视觉标识',

    recentQueries: '最近查询',
    clear: '清空',
    confirmClear: '确认清空',
    clearHistoryConfirm: '确定要清空查询历史吗？',
    clearSuccess: '清空成功',
    genuine: '正品',
    fake: '假冒',

    haveQuestions: '使用中遇到问题？',
    viewFAQ: '查看常见问题',
    contactCustomerService: '联系客服',
    contactUs: '联系我们',

    enterCodeFirst: '请输入防伪码',
    enterStyleNumberFirst: '请输入款号',
    enterPackageCodeFirst: '请输入包装防伪码',
    scanFunction: '扫码功能'
  }
}
